import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RequestsService} from '#req';
import * as _ from 'lodash';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {

  roles: any[];
  missingRole;

  constructor(private requests: RequestsService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.requests.getAllPermission().subscribe((response: any) => {
      this.roles = response.permissions;
      this.missingRole = _.get(this.roles, _.toLower(this.route.snapshot.queryParams['missingRole']));
    });
  }

  goBack() {
    window.history.back();
  }

}
